import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CatalogFieldMappingConfig } from '@nousmedis/cc-types';
import { ApiService } from '../../api/services/api.service';

@Injectable()
export class FieldMappingService {
  private get urlBase(): string { return this.api.getBaseUrl(); }
  private get endPointCatalogs(): string { return this.urlBase + '/api/v1/catalogs'; }

  constructor(private api: ApiService) {}

  getFieldMapping(idCatalog: string) {
    return this.api.get(`${this.endPointCatalogs}/${idCatalog}/field-mapping`);
  }

  saveFieldMapping(idCatalog: string, config: CatalogFieldMappingConfig) {
    return this.api.post(`${this.endPointCatalogs}/${idCatalog}/field-mapping`, config);
  }

  async getImportPreview(idCatalog: string): Promise<{
    productFields: string[];
    categoryFields: string[];
    sampleProducts: any[];
    sampleCategories: any[];
  }> {
    return firstValueFrom(
      this.api.get(`${this.endPointCatalogs}/${idCatalog}/import-preview`)
    );
  }
}
